import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../components/ui/Input';
import { Checkbox } from '../../../../../components/ui/Checkbox';
import type { HeaderSettings as HeaderSettingsType } from '../types';

interface HeaderSettingsProps {
  settings: HeaderSettingsType;
  onUpdate: (field: keyof HeaderSettingsType, value: unknown) => void;
}

const HeaderSettings: React.FC<HeaderSettingsProps> = ({ settings, onUpdate }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <h4 className="text-sm font-medium text-foreground mb-4">
        {t('Header Settings')}
      </h4>

      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label={t('Company Name')}
            value={settings.companyName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate('companyName', e.target.value)
            }
            placeholder="Company Name LLC"
          />
          <Input
            label={t('Header Text')}
            value={settings.headerText}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate('headerText', e.target.value)
            }
            placeholder="Monthly Payslip"
          />
        </div>

        <div className="flex items-center gap-6">
          <Checkbox
            checked={settings.showDate}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate('showDate', e.target.checked)
            }
            label={t('Show generation date')}
          />
          <Checkbox
            checked={settings.showPeriod}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate('showPeriod', e.target.checked)
            }
            label={t('Show pay period')}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2" data-testid="color-picker">
            <label className="block text-sm font-medium text-foreground">
              {t('Header Text Color')}
            </label>
            <div className="flex items-center gap-2">
              <input
                type="color"
                value={settings.headerColor}
                onChange={(e) => onUpdate('headerColor', e.target.value)}
                className="w-10 h-10 rounded border border-border cursor-pointer"
              />
              <Input
                value={settings.headerColor}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onUpdate('headerColor', e.target.value)
                }
                placeholder="#1f2937"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-foreground">
              {t('Header Background Color')}
            </label>
            <div className="flex items-center gap-2">
              <input
                type="color"
                value={settings.headerBackgroundColor}
                onChange={(e) => onUpdate('headerBackgroundColor', e.target.value)}
                className="w-10 h-10 rounded border border-border cursor-pointer"
              />
              <Input
                value={settings.headerBackgroundColor}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onUpdate('headerBackgroundColor', e.target.value)
                }
                placeholder="#f9fafb"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSettings;
